import LoginImg from "../assets/images/loginSura.png";
import LogoSura from "../assets/images/LogoSURA.svg";
export const images = {
  LoginImg,
  LogoSura,
};
